/**
 * 	lazily adds a script to the window object
 * 	if already added does nothing
 *
 * 	note: callback is causing an infinite loop on render, commenting it out until understanding render better
 */
import React, { useState, useEffect } from 'react';
import validSvc from '../validSvc';
import { LazyScriptLoaderProps } from './types';

const LazyScriptLoader = (props: LazyScriptLoaderProps): JSX.Element => {
    const [isLoaded, setLoaded] = useState('false');
    const { id, src, type } = props;

    // params
    if (!validSvc.isText(id) || !validSvc.isText(src)) {
        throw new Error('core/lazyScript, id and path required');
    }

    useEffect(() => {
        const elem = document.getElementById(id);
        if (elem) {
            setLoaded('true');
        } else {
            // add to body
            const script = document.createElement('script');
            script.src = src;
            script.id = id;
            if (!!type) {
                script.type = type;
            }
            document.body.appendChild(script);
            script.onload = onLoad;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    function onLoad(): void {
        setLoaded('true');
    }

    return (
        <div
            id={'lazy-' + id}
            data-loaded={isLoaded}
        ></div>
    );
};

export default LazyScriptLoader;
